export const i18n = {
  en: {
    select_all_collections: "Select all collections",
    deselect_all_collections: "Deselect all collections",
    request: "Request",
    close: "Close",
    home: "Back to the catalogue",
    view: "View",
    email: "Email",
    add: "Add",
    add_all: "Add all",
    remove: "Remove",
    remove_all: "Remove all",
    send_to_negotiator: "Send to the Negotiator",
    send_to_podium: "Send to Podium",
    card_biobank_details: "Organisation",
    card_collections_details: "Collections",
    match_option1: "Match all",
    match_option2: "Match any",
    filter_loading: "Loading filters",
    select_all: "Select all",
    deselect_all: "Deselect all",
    biobank_withdrawn: "This biobank is no longer part of BBMRI-ERIC",
    collection_withdrawn: "This collection is no longer part of BBMRI-ERIC",
    collection_biobank_withdrawn:
      "This collection belongs to a biobank that is no longer part of BBMRI-ERIC",
  },
};
